/* AF Fits Pro Night behaviour: header, mega menu, search panel, hero carousel, rails,
   product cards and the product gallery. theme.js still handles drawers, the cart,
   the size guide, the fit finder and the club-order grid. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const C = window.PNCatalog;
  const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const searchUrl = (q) => `${C ? C.ROOT : '/'}search?q=${encodeURIComponent(q)}`;

  /* A style card: one card per style, colour dots swap the photo on hover. */
  const styleCard = (s, i) => {
    const c0 = s.colours[0];
    const money = C.money;
    const flag = s.collections.includes('Limited edition') ? 'Limited release' : s.collections.includes('Summer 2026') ? 'Just in' : '';
    const price = s.pack
      ? `<span class="p-card__price">${money(s.unit)} each</span><span class="p-card__unit">Pack of ${s.pack}, ${money(s.min)}</span>`
      : `<span class="p-card__price">${s.min !== s.max ? 'From ' : ''}${money(s.min)}</span>`;
    const dots = s.colours.length > 1
      ? `<span class="p-card__dots" aria-hidden="true">${s.colours.slice(0, 6).map((c, k) => `<span class="p-card__dot" style="--sw:${c.swatch}" data-img="${esc(c.img)}" data-style="${esc(c.style || '')}" title="${esc(c.name)}"${k === 0 ? ' aria-current="true"' : ''}></span>`).join('')}${s.colours.length > 6 ? `<span class="p-card__more">+${s.colours.length - 6}</span>` : ''}</span>`
      : '';
    // Hover shows the on-model shot when the shoot has one, as Nike's cards do; else the second photo.
    const look = window.PNLooks ? window.PNLooks.forItem(s.name, c0.name)[0] : '';
    const alt = look || (c0.img2 ? C.img(c0.img2, 600) : '');
    return `
      <a class="p-card" href="${C.productUrl(c0.handle)}" style="--i:${i % 12}">
        <span class="p-card__media">
          ${c0.img ? `<img src="${C.img(c0.img, 600)}" alt="${esc(s.name)}" loading="${i < 6 ? 'eager' : 'lazy'}" width="600" height="600">` : ''}
          ${alt ? `<img class="alt${look ? ' alt--look' : ''}" src="${alt}" alt="" loading="lazy" width="600" height="600">` : ''}
        </span>
        ${dots}
        ${flag ? `<span class="p-card__flag">${flag}</span>` : ''}
        <span class="p-card__name">${esc(s.name)}</span>
        <span class="p-card__kind">${s.kind === 'Bulk packs' ? 'Bulk pack' : s.kind}${s.colours.length > 1 ? `, ${s.colours.length} colours` : ''}</span>
        ${c0.style ? `<span class="p-card__sku" data-card-style>Style ${esc(c0.style)}</span>` : ''}
        ${price}
      </a>`;
  };
  // Hovering a colour dot shows that colour's photo.
  document.addEventListener('mouseover', (e) => {
    const dot = e.target.closest('.p-card__dot');
    if (!dot || !dot.dataset.img) return;
    const cardEl = dot.closest('.p-card');
    const img = cardEl.querySelector('.p-card__media img:not(.alt)');
    if (img) img.src = C.img(dot.dataset.img, 600);
    const styleEl = cardEl.querySelector('[data-card-style]');
    if (styleEl && dot.dataset.style) styleEl.textContent = `Style ${dot.dataset.style}`;
    cardEl.querySelectorAll('.p-card__dot').forEach((d) => d.setAttribute('aria-current', d === dot));
  });
  window.PNStyleCard = styleCard;

  /* ---------- Search panel: live results from the catalogue ---------- */
  const initSearch = () => {
    const panel = document.getElementById('SearchPanel');
    if (!panel || !C) return;
    const input = panel.querySelector('input');
    const out = panel.querySelector('[data-search-results]');
    const label = panel.querySelector('[data-search-label]');
    const all = panel.querySelector('[data-search-all]');
    let styles = [];
    const render = () => {
      const q = input.value.trim();
      if (!q) { out.innerHTML = ''; label.textContent = ''; all.hidden = true; return; }
      const hits = C.search(styles, q);
      label.textContent = hits.length ? `${hits.length} ${hits.length === 1 ? 'style' : 'styles'} for "${q}"` : `Nothing for "${q}". Try "hoodie", "crop" or "polo".`;
      out.innerHTML = hits.slice(0, 10).map(styleCard).join('');
      all.hidden = hits.length <= 10;
      all.href = searchUrl(q);
    };
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('.pn-search, .search-icon, .pn-search-open');
      if (!opener) return;
      e.preventDefault();
      panel.showModal();
      C.load().then((s) => { styles = s; render(); }, () => { label.textContent = 'Search is unavailable right now. Press Enter to search the store.'; });
      setTimeout(() => input.focus(), 50);
    });
    input.addEventListener('input', render);
    panel.querySelector('form').addEventListener('submit', (e) => { e.preventDefault(); if (input.value.trim()) location.href = searchUrl(input.value.trim()); });
    panel.querySelectorAll('[data-pop]').forEach((b) => b.addEventListener('click', () => { input.value = b.textContent; render(); input.focus(); }));
    panel.addEventListener('click', (e) => { if (e.target === panel || e.target.closest('[data-search-close]')) panel.close(); });
  };

  /* ---------- Club number: required before checkout ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-checkout]');
    if (!form) return;
    const input = form.querySelector('[name="attributes[Club number]"]');
    const err = form.querySelector('[data-club-error]');
    if (input && input.value.trim() && !/^\s*\d{3,6}\s*$/.test(input.value)) {
      e.preventDefault();
      input.setAttribute('aria-invalid', 'true');
      if (err) err.textContent = 'Club numbers are 3 to 6 digits. Leave it empty for a personal order.';
      input.focus();
      return;
    }
    if (input) { input.removeAttribute('aria-invalid'); if (err) err.textContent = ''; }
    // Valid: the form posts to /cart, which saves the club number and opens checkout.
  });
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[name="attributes[Club number]"]')) return;
    e.target.removeAttribute('aria-invalid');
    const err = e.target.closest('form').querySelector('[data-club-error]');
    if (err) err.textContent = '';
  });

  /* ---------- Bag page: order sheet download ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bag-csv]');
    if (!btn) return;
    const cell = (v) => `"${String(v).replace(/"/g, '""')}"`;
    const rows = [['SKU', 'Item', 'Options', 'Quantity', 'Unit price', 'Line total']]
      .concat([...document.querySelectorAll('.bag [data-line]')].map((li) => {
        const d = li.dataset;
        return [d.sku || '', d.title || '', d.options || '', d.qty, (Number(d.unit) / 100).toFixed(2), (Number(d.unit) * Number(d.qty) / 100).toFixed(2)];
      }));
    const blob = new Blob([rows.map((r) => r.map(cell).join(',')).join('\r\n')], { type: 'text/csv' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'af-fits-order-sheet.csv';
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  });

  /* ---------- Fill content from real products ---------- */
  const fill = () => {
    if (!C) return;
    const mosaic = document.querySelector('[data-mosaic]');
    const rails = [...document.querySelectorAll('[data-rail-handles]')];
    if (!mosaic && !rails.length) return;
    C.load().then((styles) => {
      if (mosaic) {
        const pool = styles.filter((s) => s.colours[0].img && !['Bags', 'Socks', 'Club supplies', 'Bulk packs'].includes(s.kind)).slice(0, 24);
        // Diagonal stagger: tiles closer to the top-left arrive first.
        mosaic.innerHTML = pool.map((s, i) => `<div class="mosaic__tile" style="--d:${(i % 8) + Math.floor(i / 8) * 2}"><img src="${C.img(s.colours[0].img, 360)}" alt="" loading="${i < 16 ? 'eager' : 'lazy'}"></div>`).join('');
      }
      rails.forEach((rail) => {
        const handles = rail.dataset.railHandles.split(/[\s,]+/).filter(Boolean);
        let list = handles.map((h) => (C.find(styles, h) || {}).style).filter(Boolean);
        if (!list.length) list = styles.filter((s) => s.colours[0].img).slice(0, 10);
        rail.innerHTML = [...new Set(list)].map(styleCard).join('');
      });
      initRails();
    }, () => {
      rails.forEach((rail) => { rail.closest('[data-rail]').hidden = true; });
    });
  };

  /* ---------- Header: hide on scroll down, Nike's sharp in-out ---------- */
  const initHeader = () => {
    const h = document.querySelector('.pn-header');
    if (!h) return;
    let last = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const open = document.querySelector('.pn-nav__item.is-open, dialog[open]');
      const hide = !open && y > 200 && y > last;
      h.classList.toggle('is-hidden', hide);
      document.body.classList.toggle('header-hidden', hide);
      last = y;
    }, { passive: true });
  };

  /* ---------- Mega menu (hover with intent delay, click/keyboard friendly) ---------- */
  const initMega = () => {
    const scrim = document.querySelector('.mega-scrim');
    document.querySelectorAll('.pn-nav__item[data-mega]').forEach((item) => {
      const btn = item.querySelector('.pn-nav__link');
      let t;
      const open = (on) => {
        item.classList.toggle('is-open', on);
        btn.setAttribute('aria-expanded', on);
        if (scrim) scrim.classList.toggle('is-on', on);
      };
      item.addEventListener('mouseenter', () => { clearTimeout(t); t = setTimeout(() => open(true), 120); });
      item.addEventListener('mouseleave', () => { clearTimeout(t); t = setTimeout(() => open(false), 160); });
      btn.addEventListener('click', () => open(!item.classList.contains('is-open')));
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { open(false); btn.focus(); } });
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) open(false); });
    });
  };

  /* ---------- Hero carousel ---------- */
  const initHero = () => {
    const hero = document.querySelector('[data-hero]');
    if (!hero) return;
    const track = hero.querySelector('.hero__track');
    const slides = [...hero.querySelectorAll('.hero__slide')];
    const dots = [...hero.querySelectorAll('.hero__dot')];
    const pause = hero.querySelector('.hero__pause');
    const ms = Number(hero.dataset.slideMs) || 7000;
    hero.style.setProperty('--slide-ms', `${ms}ms`);
    let i = 0; let timer; let playing = !reduce && slides.length > 1;

    const restart = () => {
      clearTimeout(timer);
      hero.classList.remove('is-playing'); void hero.offsetWidth;
      if (playing) { hero.classList.add('is-playing'); timer = setTimeout(() => go(i + 1), ms); }
    };
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(${-100 * i}%)`;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k !== i); });
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i));
      restart();
    };
    const setPlaying = (on) => {
      playing = on;
      if (pause) {
        pause.setAttribute('aria-label', on ? 'Pause slideshow' : 'Play slideshow');
        pause.querySelector('.ico-pause').style.display = on ? '' : 'none';
        pause.querySelector('.ico-play').style.display = on ? 'none' : '';
      }
      restart();
    };
    const prev = hero.querySelector('[data-prev]');
    const next = hero.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => go(i - 1));
    if (next) next.addEventListener('click', () => go(i + 1));
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    if (pause) pause.addEventListener('click', () => setPlaying(!playing));
    // Swipe on touch screens
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1));
    });
    // Don't advance while someone is reading or the tab is hidden.
    hero.addEventListener('mouseenter', () => { if (playing) { clearTimeout(timer); hero.classList.remove('is-playing'); } });
    hero.addEventListener('mouseleave', restart);
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(timer); else restart(); });

    const start = () => { hero.classList.add('is-ready'); go(0); setPlaying(playing); };
    const first = hero.querySelector('.hero__img');
    Promise.race([
      first && !first.complete ? new Promise((r) => { first.onload = first.onerror = r; }) : Promise.resolve(),
      new Promise((r) => setTimeout(r, 1200)),
    ]).then(() => requestAnimationFrame(start));
  };

  /* ---------- Rails: arrows that disable at the ends ---------- */
  const initRails = () => {
    document.querySelectorAll('[data-rail]').forEach((rail) => {
      const track = rail.querySelector('.rail__track');
      if (!track) return;
      if (rail.dataset.ready) { track.dispatchEvent(new Event('scroll')); return; }
      rail.dataset.ready = '1';
      const prev = rail.querySelector('[data-rail-prev]');
      const next = rail.querySelector('[data-rail-next]');
      if (!prev || !next) return;
      const update = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };

  /* ---------- Product gallery: thumbnails swap the main image on hover, arrows step ---------- */
  const initPdp = () => {
    const g = document.querySelector('[data-pdp-gallery]');
    if (!g) return;
    const stage = g.querySelector('.pdp__stage img');
    const thumbs = [...g.querySelectorAll('.pdp__thumb')];
    if (!stage || !thumbs.length) return;
    let i = 0;
    const slot = g.querySelector('[data-pdp-slot]');
    const show = (n) => {
      i = (n + thumbs.length) % thumbs.length;
      const next = thumbs[i].dataset.full;
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i));
      // Photo slots mark where on-model shots go until they're photographed.
      if (slot) {
        const isSlot = Boolean(thumbs[i].dataset.slot);
        slot.classList.toggle('is-on', isSlot);
        if (isSlot) {
          slot.querySelector('[data-slot-title]').textContent = thumbs[i].dataset.slot;
          slot.querySelector('[data-slot-note]').textContent = thumbs[i].dataset.note || '';
          return;
        }
      }
      if (stage.dataset.src === next && stage.dataset.idx === String(i)) return;
      stage.dataset.idx = String(i);
      stage.classList.add('is-leaving');
      const img = new Image(); img.src = next;
      const swap = () => {
        stage.src = next; stage.dataset.src = next; stage.alt = thumbs[i].dataset.alt;
        // Campaign photos are full-colour scenes: show them as shot, not blended into the tile.
        stage.classList.toggle('is-look', thumbs[i].classList.contains('pdp__thumb--look'));
        requestAnimationFrame(() => stage.classList.remove('is-leaving'));
      };
      (img.decode ? img.decode() : Promise.resolve()).then(swap, swap);
    };
    thumbs.forEach((t, k) => { t.addEventListener('mouseenter', () => show(k)); t.addEventListener('click', () => show(k)); t.addEventListener('focus', () => show(k)); });
    const prev = g.querySelector('[data-prev]');
    const next = g.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => show(i - 1));
    if (next) next.addEventListener('click', () => show(i + 1));
  };

  window.PN = { initPdp, initRails };
  const init = () => { fill(); initHeader(); initMega(); initHero(); initRails(); initPdp(); initSearch(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Sections re-render in the theme editor: wire the new markup.
  document.addEventListener('shopify:section:load', () => { fill(); initHero(); initRails(); });
})();
